import ResponsiveStyleSheet from "react-native-media-query";
import { theme } from "@clearabee/ui-library-native";

export const { styles, ids } = ResponsiveStyleSheet.create({
  welcomeWrapper: {
    width: 300,
    marginRight: theme.spacing.small,
    paddingTop: theme.spacing.medium,
  },
  largeWelcomeBack: {
    borderBottomColor: theme.colors.brand.light,
    borderBottomWidth: 1,
    marginHorizontal: theme.spacing.large,
    paddingBottom: theme.spacing.large,
  },
  panel: {
    backgroundColor: theme.colors.brand.darkest,
    padding: theme.spacing.small,
    marginBottom: theme.spacing.small,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  sidebarBackground: {
    backgroundColor: theme.colors.brand.darkest,
    width: 300,
    position: "absolute",
    bottom: -1,
    top: -100,
  },
  cornerWrapper: {
    position: "absolute",
    height: theme.spacing.small,
    bottom: -17,
    width: theme.spacing.small,
    backgroundColor: theme.colors.brand.darkest,
  },
  corner: {
    width: "105%",
    height: "105%",
    backgroundColor: theme.colors.accent.base,
    borderTopLeftRadius: theme.spacing.xsmall,
  },
  logout: {
    position: "absolute",
    bottom: theme.spacing.xlarge3,
    width: "100%",
  },
  modalIcon: {
    marginTop: theme.spacing.large,
    marginBottom: theme.spacing.small,
  },
  modalActions: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: theme.spacing.large,
  },
});
